import { ActivityComponentFactory } from './druid/types/ActivityMiddleware';
import useCreateActivityRendererInternal from '/druid/internal/useCreateActivityRendererInternal';

// The newer useCreateActivityRenderer() hook does not support override renderAttachment().
// Only the deprecated useRenderActivity() hook support overriding renderAttachment().
export default function useCreateActivityRenderer(): ActivityComponentFactory {
  return useCreateActivityRendererInternal();
}
